import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    name,
    desc = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.common.uDictionary.saveCate, {
        id,
        name,
        desc,
    }, options);
    if (error) return { error, status };
    return content || {};
};
